var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-detail" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: this.$t("whatsappChannel.channelName"),
                    name: "channelName",
                  },
                  model: {
                    value: _vm.clone.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "name", $$v)
                    },
                    expression: "clone.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsappChannel.phoneNummer")) +
                      " (E164 Format)"
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: "Phone Number (E164 Format). ex: 908501234455",
                    name: "phoneNumber",
                  },
                  model: {
                    value: _vm.clone.payload.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                    },
                    expression: "clone.payload.phoneNumber",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "mt-1 mb-1" },
                  [
                    _c("a-switch", {
                      attrs: { checked: !!_vm.clone.chatbotStory },
                      on: { click: _vm.toggleChatbot },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "👉 " +
                          _vm._s(_vm.$t("whatsappChannel.forwardToChatbot"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsappChannel.forwardingChatbotOrLiveAgent")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: {
                      defaultValue: null,
                      notFoundContent: "👉 Forward Live Agents",
                      disabled: !_vm.showStories,
                    },
                    model: {
                      value: _vm.clone.chatbotStory,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "chatbotStory", $$v)
                      },
                      expression: "clone.chatbotStory",
                    },
                  },
                  [
                    !_vm.checkHaveChatbotStory(_vm.clone.chatbotStory)
                      ? _c(
                          "a-select-option",
                          { attrs: { selected: true, value: null } },
                          [
                            _vm._v(
                              "\n                        👉 Forward Live Agents\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.stories, function (story) {
                      return _c(
                        "a-select-option",
                        { key: story._id, attrs: { value: story._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(story.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [_vm._v("Department Forwarding Rule")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-1 mb-1" },
                      [
                        _c("a-switch", {
                          attrs: { checked: !!_vm.clone.forwardDepartment },
                          on: { click: _vm.toggleDepartmentForwardingRule },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("👉 Department Forwarding Rule Enabled"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.clone.forwardDepartment
                      ? _c(
                          "a-select",
                          {
                            attrs: { defaultValue: null },
                            model: {
                              value: _vm.clone.forwardDepartment,
                              callback: function ($$v) {
                                _vm.$set(_vm.clone, "forwardDepartment", $$v)
                              },
                              expression: "clone.forwardDepartment",
                            },
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { selected: true, value: "null" } },
                              [_vm._v("👉Selected Department...")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.departments, function (department) {
                              return _c(
                                "a-select-option",
                                {
                                  key: department._id,
                                  attrs: { value: department._id },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getDepartmentTitle(department)
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showVisibilityConfig
              ? _c("VisibilityChanger", {
                  model: {
                    value: _vm.clone.visibility,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "visibility", $$v)
                    },
                    expression: "clone.visibility",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-button",
              { staticClass: "cancel-btn", on: { click: _vm.handleCancel } },
              [_vm._v(_vm._s(_vm.$t("billing.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.updateChannelData },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("Whatsapp V1 Channel Detail"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("Manage your whatsapp v1 channel"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }